import { FC, PropsWithChildren } from 'react';
import { StyledHeader } from './Header.styles';

const Header: FC<PropsWithChildren> = ({ children }) => (
  <StyledHeader className="app-shell-header">{children}</StyledHeader>
);

export default Header;
